export default __webpack_public_path__ + "static/media/hindi_agri_f.26685c2e.wav";